import { useMemo } from 'react';

import { containFit, type Fit, type Size } from '../../lib/geometry';
import type { Picture } from '../state/editor';

/** Contain-fit the picture into the measured stage. Null until both are known. */
export function useFit(stage: Size | null, picture: Picture | null): Fit | null {
  return useMemo(
    () => (stage === null || picture === null ? null : containFit(stage, picture.natural)),
    [stage, picture],
  );
}
